module.exports = __webpack_public_path__ + "Tinebase/js/ace-theme-pastel_on_dark-FAT.js";